import { Box, styled, Typography, useTheme } from "@mui/material";
import { RefObject } from "react";
import { Col, Row } from "v2/components/base/Flex/ui";
import CabalTownLogo from "assets/icons/cabal-town-logo-v2.png";
import { ViewPoint } from "v2/components/base/ResponsiveLayout/ui";

interface OnBoardingItemProps {
  image: string;
  title: string;
  description: string;
  scrollRef: RefObject<HTMLDivElement>;
  inViewRef: RefObject<HTMLDivElement>;
}

const OnBoardingItem = ({
  image,
  title,
  description,
  inViewRef,
  scrollRef,
}: OnBoardingItemProps) => {
  const theme = useTheme();
  return (
    <>
      <ViewPoint.Mobile>
        <Col
          type="ec"
          ref={scrollRef}
          sx={{
            textAlign: "center",
            padding: "20px 0",
            minWidth: "100%",
            scrollSnapAlign: "start",
          }}
          fullWidth
          fullHeight>
          <img src={CabalTownLogo} alt="cabal-town-logo" height="25px" />
          <Row sx={{ height: "40px" }} />
          <Col
            ref={inViewRef}
            type="bc"
            sx={{ gap: "16px", maxWidth: "297px", margin: "0 auto" }}
            fullWidth>
            <Typography
              variant="mobile-h2"
              sx={{ textTransform: "capitalize" }}
              color={theme.palette.text.primary}>
              {title.toLowerCase()}
            </Typography>
            <Typography variant="mobile-body-s" color={theme.palette.text.primary}>
              {description}
            </Typography>
          </Col>
          {/* <Box sx={{ height: "160px" }} /> */}
        </Col>
      </ViewPoint.Mobile>
      <ViewPoint.Desktop>
        <Col
          type="es"
          ref={scrollRef}
          sx={{
            textAlign: "center",
            padding: "20px",
            minWidth: "100%",
            scrollSnapAlign: "start",
          }}
          fullWidth
          fullHeight>
          <img src={CabalTownLogo} alt="cabal-town-logo" height="44px" />
          <Row sx={{ height: "20px" }} />
          <Col
            ref={inViewRef}
            type="bs"
            sx={{ gap: "16px", maxWidth: "297px", textAlign: "start" }}
            fullWidth>
            <Typography
              variant="mobile-h2"
              sx={{ textTransform: "capitalize" }}
              color={theme.palette.text.primary}>
              {title.toLowerCase()}
            </Typography>
            <Typography variant="mobile-body-s" color={theme.palette.text.primary}>
              {description}
            </Typography>
          </Col>
          {/* <Box sx={{ height: "160px" }} /> */}
        </Col>
      </ViewPoint.Desktop>
    </>
  );
};

const OnboardingImage = styled("img")(({ theme }) => ({
  width: "80%",
  maxWidth: "400px",
  aspectRatio: "1/1",
}));

export { OnBoardingItem };
